function getEnv() {
  return {
    API_BE_URL: process.env.REACT_APP_API_BE_URL,
    AUTH0_DOMAIN: process.env.REACT_APP_AUTH0_DOMAIN,
    AUTH0_CLIENT_ID: process.env.REACT_APP_AUTH0_CLIENT_ID,
    AUTH0_REDIRECT_URI: process.env.REACT_APP_AUTH0_REDIRECT_URI,
    API_AUDIENCE: process.env.REACT_APP_API_AUDIENCE,
  };
}

const env = getEnv();
export default env;
